import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import logo from "../assets/images/mmplay.png";
import Betfair from "../assets/images/provider/Betfair.jpg";

import EvolutionGames from "../assets/images/provider/provider-logo-evolution.png";
import EzugiGames from "../assets/images/provider/provider-logo-ezugi.png";
import QtechGames from "../assets/images/provider/provider-logo-Qtech.png";
import SupernowaGames from "../assets/images/provider/provider-logo-supernowa.jpg";
import VirtualSports from "../assets/images/provider/provider-logo-virtualSports.jpg";
import VIVOGames from "../assets/images/provider/provider-logo-vivo.png";
import WorldCasino from "../assets/images/provider/provider-logo-Worldcasino.jpg";
import XPGGames from "../assets/images/provider/provider-logo-XPG.jpg";
import { useSelector } from "react-redux";

import FbIconImg from "../assets/images/provider/facebook.png";
import InstaIconImg from "../assets/images/provider/instagram.png";
import BankImg from "../assets/images/payments/new/mobile-banking.png";

import binance from "../assets/images/payments/new/Binance.png";
import pmicon from "../assets/images/payments/new/Pm.png";
import therthnt from "../assets/images/payments/new/Tether.png";
import Bitcoin from "../assets/images/payments/new/Bitcoin.png";
import Phonepay from "../assets/images/payments/new/phonepe-logo-icon.png";
import Paytm from "../assets/images/payments/new/Paytm.png";
import GooglaPay from "../assets/images/payments/new/Gpay.png";
import UPIcon from "../assets/images/payments/new/Upi.png";

import Calling1 from "../assets/images/icons/phone.png";
import Whatapps from "../assets/images/icons/whatsapp.png";
import Telegram from "../assets/images/icons/telegram.png";
import Mail from "../assets/images/icons/mail.png";

import WhatsaPPImg from "../assets/images/icons/whatsappfoot.png";
import TelegramImg from "../assets/images/icons/telegramfoot.png";
import BottomNav from "./BottomNav";

const BeforeLoginFooter = () => {
  const { appDetails } = useSelector((state) => state.app);
  return (
    <>
      <footer className="footer">
        <Container>
          <div className="sectionDivide">
            <div className="singleSection">
              <div className="footer-logo">
                <a href="#" className="footerImg">
                  <img src={appDetails?.LOGO_URL || logo} alt="Logo" />
                </a>
                <div className="social-icons">
                  <ul>
                    <li>
                      <a
                        href={
                          appDetails?.FACEBOOK != ""
                            ? appDetails?.FACEBOOK
                            : "javascript:void(0)"
                        }
                        target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                      >
                        <img src={FbIconImg} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          appDetails?.INSTATGRAM != ""
                            ? appDetails?.INSTATGRAM
                            : "javascript:void(0)"
                        }
                        target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                      >
                        <img src={InstaIconImg} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          appDetails?.TELEGRAM != ""
                            ? appDetails?.TELEGRAM
                            : "javascript:void(0)"
                        }
                        target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                      >
                        <img src={TelegramImg} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "javascript:void(0)"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsaPPImg} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="foot-discription">
                <p>
                  We are dedicated to making sure you have a great time playing
                  games on Indoplay while also being well aware of the negative
                  social and financial implications of excessive gaming. We
                  provide and advertise our games as delightful forms of
                  entertainment because we think that only when players play
                  sensibly and in moderation will gaming remain as such.
                </p>
              </div>
            </div>
            <div className="singleSection">
              <div className="providers_logo">
                <h5>Gaming Partner</h5>
                <ul>
                  <li>
                    <img src={Betfair} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={EvolutionGames} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={EzugiGames} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={QtechGames} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={SupernowaGames} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={VirtualSports} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={VIVOGames} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={WorldCasino} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={XPGGames} alt="Providers Logo" />
                  </li>
                </ul>
              </div>
              <div className="paymentspartner">
                <h5>Payments Partners</h5>
                <ul>
                  <li>
                    <img src={UPIcon} />
                  </li>
                  <li>
                    <img src={GooglaPay} />
                  </li>
                  <li>
                    <img src={Paytm} />
                  </li>
                  <li>
                    <img src={Phonepay} />
                  </li>
                  <li>
                    <img src={BankImg} />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Container>

        <div className="footer-links">
          <Container>
            <Row>
              <Col xs={12}>
                <ul>
                  <li>
                    <a href="/contacts">Contact Us</a>
                  </li>
                  <li>
                    <a href="/privacypolicys">Privacy Policy</a>
                  </li>

                  <li>
                    <a href="/ResponsibleGamings">Responsible Gaming</a>
                  </li>
                  <li>
                    <a href="/fairplays">Fair Play</a>
                  </li>
                  <li>
                    <a href="/gameruless">Games Rules</a>
                  </li>
                  <li>
                    <a href="/termsandconditions">Terms and Conditions</a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>

        <BottomNav />
      </footer>
    </>
  );
};

export default BeforeLoginFooter;
